var notTo = [
    '故宫',
    '团城',
    '颐和园',
    '雍和宫',
    '恭王府',
    '国子监',
    '京西古道',
    '七彩蝶园',
    '非遗博物馆',
    '国家博物馆',
    '红砖美术馆',
    '昆虫博物馆',
    '历代帝王庙',
    '美克洞学馆',
    '蜜蜂博物馆',
    '民族博物馆',
    '蘑菇博物馆',
    '农业博物馆',
    '钱币博物馆',
    '人定湖公园',
    '人民大会堂',
    '顺义博物馆',
    '坦克博物馆',
    '陶瓷文化馆',
    '体育博物馆',
    '延庆博物馆',
    '炎黄艺术馆',
    '印刷博物馆',
    '紫檀博物馆',
    '93号院博物馆',
    '北京市方志馆',
    '昌平区博物馆',
    '地道战纪念馆',
    // '海淀区博物馆',
    '老爷车博物馆',
    '麋鹿苑博物馆',
    '密云区博物馆',
    '南池子美术馆',
    '轻武器博物馆',
    '通州区博物馆',
    '五洲植物乐园',
    '西黄寺博物馆',
    '中医药博物馆',
    '保利艺术博物馆',
    '北京奥运博物馆',
    '北京茶叶博物馆',
    '北京果脯博物馆',
    '北京金石博物馆',
    '北京民俗博物馆',
    '北京税务博物馆',
    '北京陶瓷艺术馆',
    '北京戏曲博物馆',
    '插花艺术博物馆',
    '东四胡同博物馆',
    '古代建筑博物馆',
    '古陶文明博物馆',
    '华夏珍宝博物馆',
    '金殿水晶博物馆',
    '科举匾额博物馆',
    '老牛儿童探索馆',
    '琉璃河商周遗址',
    '明十三陵博物馆',
    '声音艺术博物馆',
    '史家胡同博物馆',
    '首都粮食博物馆',
    '天桥印象博物馆',
    '西周燕都博物馆',
    '邮政邮票博物馆',
    '中国电信博物馆',
    '中国航天博物馆',
    '中国科学技术馆',
    '中国律师博物馆',
    '中国民族博物馆',
    '中国西瓜博物馆',
    '中国现代文学馆',
    '中国油画陈列馆',
    '北京大运河博物馆',
    '北京二锅头博物馆',
    '北京自来水博物馆',
    '景泰蓝艺术博物馆',
    '赛克勒考古博物馆',
    '宋庆龄科学技术馆',
    '王老吉凉茶博物馆',
    '中国帽文化博物馆',
    '北京宦官文化陈列馆',
    '北京燕京八绝博物馆',
    '南锣鼓巷时间博物馆',
    '世界地质公园博物馆',
    '中国华侨历史博物馆',
    '中国京西皮影博物院',
    '北京城市副中心图书馆',
    '北京故宫博物院北院区',
    '北京荣唐连环画博物馆',
    '唐人坊中国人偶博物馆',
    '北京金漆镶嵌艺术博物馆',
    '周口店北京人遗址博物馆',
    '中国航空工业历史博物馆',
    '珐琅书法牌匾博物馆',
    '神州连环画博物馆',
    '路县故城遗址博物馆',
    '法原博物馆',
    '视障文化博物馆'
]

var bowuguan = [
    [116.403757, 39.916727, '故宫'],
    [116.348486, 39.911876, '首都博物馆'],
    [116.403757, 39.916727, '国家博物馆'],
    // [116.325530, 39.982485, '海淀区博物馆'],
    [116.677106, 40.116104, '顺义博物馆'],
    [116.673882, 39.914110, '通州区博物馆'],
    [116.842419, 40.382814, '密云区博物馆'],
    [115.984285, 40.472548, '延庆博物馆'],
    [116.640779, 40.322835, '怀柔博物馆'],
    [116.261704, 40.227084, '昌平区博物馆'],
    [116.406116, 39.889525, '自然博物馆'],
    [116.372885, 40.192095, '中国航空航天博物馆'],
    [116.330207, 39.914976, '革命军事博物馆'],
    [116.522415, 40.003628, '铁道博物馆(东郊)'],
    [116.527178, 40.002671, '电影博物馆'],
    [116.404125, 40.009944, '工艺美术馆'],
    [116.405433, 40.005392, '考古博物馆'],
    [116.343134, 39.944040, '天文馆'],
    [116.417686, 39.904087, '中央礼品文物管理中心'],
    [116.183773, 39.885338, '园林博物馆'],
    [116.341009, 39.943129, '古动物馆'],
    [116.389218, 40.009379, '国家动物博物馆'],
    [116.139442, 40.168155, '坦克博物馆'],
    [116.544270, 40.024063, '民航博物馆'],
    [116.357315, 39.987388, '北京航空航天博物馆'],
    [116.429985, 39.810981, '中国航天博物馆'],
    [116.375341, 39.914214, '民族文化宫'],
    [116.365278, 39.931588, '鲁迅博物馆'],
    [116.417259, 39.930527, '中国美术馆'],
    [116.404162, 39.908892, '毛主席纪念堂'],
    [116.726914, 39.967915, '体育博物馆'],
    [116.377722, 39.928967, '地质博物馆'],
    [116.469233, 39.946976, '农业博物馆'],
    [116.232474, 39.857753, '人民抗日战争纪念馆'],
    [116.227420, 39.856445, '卢沟桥历史博物馆'],
    [116.344611, 39.974916, '古钟博物馆'],
    [116.318121, 39.953022, '北京艺术博物馆'],
    [116.400119, 39.884358, '古代建筑博物馆'],
    [116.415150, 40.002016, '炎黄艺术馆'],
    [116.401377, 39.908484, '钱币博物馆'],
    [115.943510, 39.693463, '西周燕都博物馆'],
    [116.365499, 39.868291, '辽金城垣博物馆'],
    [116.303623, 39.812871, '西汉墓博物馆'],
    [116.312399, 40.001644, '赛克勒考古博物馆'],
    [116.876273, 40.240190, '地道战纪念馆'],
    [116.324769, 39.954873, '民族博物馆'],
    [116.337993, 39.748714, '印刷博物馆'],
    [116.318473, 40.019756, '圆明园展览馆'],
    [116.397809, 39.989379, '中华民族博物院'],
    [116.540397, 40.013309, '观复博物馆'],
    [116.212632, 40.012586, '蜜蜂博物馆'],
    [116.433211, 39.976518, '中医药博物馆'],
    [116.467464, 39.782489, '麋鹿苑博物馆'],
    [116.406763, 39.906222, '铁道博物馆'],
    [116.684891, 40.305098, '老爷车博物馆'],
    [116.437639, 39.916824, '邮政邮票博物馆'],
    [116.320303, 39.975885, '人民大学博物馆'],
    [116.308520, 39.835739, '汽车博物馆'],
    [116.500948, 39.990224, '遇见博物馆'],
    [116.310589, 39.896336, '公交馆'],
    [116.439511, 39.913102, '海关博物馆'],
    [116.429897, 39.916578, '妇女儿童博物馆'],
    [116.394428, 39.840734, '消防博物馆'],
    [116.411365, 39.908361, '北京警察博物馆'],
    [116.407740, 39.906237, '北京市规划展览馆'],
    [116.417323, 39.905156, '中国第一历史档案馆'],
    [115.880646, 39.590493, '世界地质公园博物馆'],
    [116.403001, 39.996847, '北京奥运博物馆'],
    [116.439208, 39.938534, '保利艺术博物馆'],
    [116.727269, 39.960245, '声音艺术博物馆'],
    [116.154286, 40.249425, '金殿水晶博物馆'],
    [116.547240, 39.904722, '科举匾额博物馆'],
    [116.532483, 39.916972, '紫檀博物馆'],
    [116.110083, 40.245566, '轻武器博物馆'],
    [116.247071, 40.284960, '明十三陵博物馆'],
    [116.354941, 39.888100, '京彩瓷博物馆'],
    [116.373959, 39.930766, '历代帝王庙'],
    [116.483150, 39.861445, '北京陶瓷艺术馆'],
    [116.444037, 39.951873, '北京自来水博物馆'],
    [116.164351, 39.941525, '北京宦官文化陈列馆'],
    [116.441338, 39.841429, '北京金漆镶嵌艺术博物馆'],
    [116.171174, 39.941959, '北京燕京八绝博物馆'],
    [116.428906, 39.924292, '史家胡同博物馆'],
    [116.426688, 39.933756, '东四胡同博物馆'],
    [116.330030, 39.639892, '中国西瓜博物馆'],
    [116.404358, 39.902502, '中国帽文化博物馆'],
    [116.671698, 40.332401, '北京二锅头博物馆'],
    [116.409799, 39.920179, '南池子美术馆'],
    [116.404083, 39.875853, '首都粮食博物馆‌'],
    [116.290178, 40.030414, '昆虫博物馆'],
    [116.723307, 39.886866, '北京大运河博物馆'],
    [116.403267, 39.946649, '南锣鼓巷-时间博物馆'],
    [116.450577, 39.930668, '北京民俗博物馆'],
    [116.396854, 39.971081, '西黄寺博物馆'],
    [116.419942, 39.870374, '景泰蓝艺术博物馆'],
    [116.513113, 39.913355, '华夏珍宝博物馆'],
    [116.434915, 39.915655, '中国律师博物馆'],
    [116.360714, 39.844973, '插花艺术博物馆'],
    [116.431543, 39.949043, '中国华侨历史博物馆'],
    [116.394097, 39.899209, '93号院博物馆'],
    [116.354625, 39.857617, '陶瓷文化馆'],
    [116.315890, 39.979125, '中国民族博物馆'],
    [115.943241, 39.693589, '周口店北京人遗址博物馆'],
    [116.334294, 39.886263, '北京茶叶博物馆'],
    [116.390494, 39.895052, '北京戏曲博物馆'],
    [116.409223, 39.941841, '非遗博物馆'],
    [116.906110, 40.468947, '中国航空工业历史博物馆'],
    [116.232867, 40.103371, '北京故宫博物院北院区'],
    [116.436684, 39.990717, '中国现代文学馆'],
    [116.365066, 39.896034, '北京空竹博物馆'],
    [116.403866, 39.889413, '天桥印象博物馆'],
    [116.370932, 39.898893, '北京宣南文化博物馆'],
    [116.361372, 39.984219, '中国电信博物馆'],
    [116.469585, 39.875498, '北京市方志馆'],
    [116.566483, 39.862102, '北京荣唐连环画博物馆'],
    [116.399903, 39.935061, '北京金石博物馆'],
    [116.453070, 39.988275, '北京税务博物馆'],
    [116.377063, 39.981553, '王老吉凉茶博物馆'],
    [116.363826, 39.879080, '古陶文明博物馆'],
    [116.748182, 39.839374, '唐人坊中国人偶博物馆'],
    [116.624894, 40.293281, '北京果脯博物馆'],
    [116.497928, 40.238439, '蘑菇博物馆'],
    [116.406960, 39.601060, '王场村地道遗址博物馆'],
    [116.300746, 39.939648, '珐琅书法牌匾博物馆'],
    [116.404495, 39.891826, '神州连环画博物馆'],
    [116.726482, 39.918407, '路县故城遗址博物馆'],
    [116.407706, 39.901275, '法原博物馆'],
    [116.394521, 39.887298, '视障文化博物馆'],
]

var jingdian = [
    [116.419342, 39.888663, '天坛'],
    [116.400824, 39.997574, '鸟巢'],
    [116.419654, 39.953183, '国子监'],
    [116.423632, 39.953638, '雍和宫'],
    [116.404153, 39.933751, '景山'],
    [116.315938, 40.005466, '圆明园'],
    [116.291621, 40.004603, '颐和园'],
    [116.395376, 39.932886, '北海公园'],
    [116.392791, 39.941922, '恭王府'],
    [116.197194, 39.881733, '园博园'],
    [116.502072, 39.991088, '798艺术区 '],
    [117.284632, 40.661046, '古北水镇'],
    [116.759092, 40.633408, '清凉谷'],
    [117.310896, 40.187348, '金海湖'],
    [116.689259, 40.467871, '青龙峡'],
    [116.690837, 40.403587, '雁栖湖'],
    [116.168840, 39.941638, '模式口大街'],
    [116.190196, 39.968527, '八大处公园'],
    [116.385158, 39.931202, '西什库教堂'],
    [116.313245, 39.925001, '中央电视塔'],
    [116.163521, 39.921718, '首钢园'],
    [116.404696, 39.903756, '杜莎夫人蜡像馆'],
    [115.909891, 39.804613, '银狐洞'],
    [116.036219, 39.900848, '八奇洞'],
    [115.949587, 39.803892, '月亮山-石花洞'],
    [115.567102, 40.028529, '龙门涧'],
    [115.966271, 40.061668, '神泉峡'],
    [116.161191, 39.740040, '昊天公园'],
    [116.362735, 39.877210, '大观园'],
    [116.157834, 39.914140, '冬奥公园'],
    [116.731526, 39.879708, '绿心公园'],
    [116.753794, 39.875816, '大运河森林公园'],
    [116.215026, 40.009399, '植物园'],
    [116.335470, 40.000232, '清华大学'],
    [116.312014, 39.993812, '北京大学'],
    [116.084842, 40.144795, '白虎涧'],
    [115.949587, 39.803892, '石花洞'],
    [116.551259, 40.423051, '慕田峪长城'],
    [116.024067, 40.362639, '八达岭长城'],
    [116.079068, 40.296759, '居庸关长城'],
    [116.326469, 39.922422, '玉渊潭'],
    [116.721031, 39.889742, '北京城市副中心图书馆'],
    [116.393593, 39.896379, '纪晓岚故居'],
    [116.395565, 39.941406, '郭沫若纪念馆'],
    [115.823578, 40.136370, '南石洋大峡谷'],
    [116.052529, 39.969417, '京西古道'],
    [117.253351, 40.232723, '京东大溶洞'],
    [116.103939, 39.848369, '绿野仙踪郊野公园'],
    [115.647125, 39.867404, '百瑞谷'],
    [115.737640, 39.847785, '圣莲山景区'],
    [115.674257, 39.623043, '乐谷银滩'],
    [116.451994, 39.929863, '美克洞学馆'],
    [116.063319, 39.622907, '琉璃河商周遗址'],
    [116.506082, 40.048801, '红砖美术馆'],
    [116.254879, 40.081588, '壹美美术馆'],
    [116.426596, 39.908885, '亚斯立堂'],
    [116.409812, 39.933938, '东景缘'],
    [116.844867, 40.412757, '密云水库展览馆'],
    [116.550211, 39.905771, '中国油画陈列馆'],
    [116.415008, 39.904268, '北京人民防空历史文化馆'],
    [116.614423, 40.055113, '西湖园'],
    [116.440066, 39.912603, '古观象台'],
    [116.395469, 39.929070, '团城'],
]

var simiao = [
    [116.037356, 39.911876, '潭柘寺'],
    [116.376434, 39.890972, '法源寺'],
    [116.092700, 39.875637, '戒台寺'],
    [116.632411, 40.390454, '红螺寺'],
    [116.189886, 39.963041, '灵光寺'],
    [115.781391, 39.615208, '云居寺'],
    [116.352588, 39.900393, '天宁寺'],
    [116.230518, 40.078371, '香岩寺'],
    [116.378703, 39.930786, '广济寺'],
    [116.349097, 39.737293, '火神庙'],
    [116.431126, 39.893713, '法华寺'],
    [116.366124, 39.896830, '报国寺'],
    [116.397336, 39.947695, '广化寺'],
    [116.113289, 40.058631, '大觉寺'],
    [116.134271, 39.859917, '娘娘庙'],
    [116.438899, 39.923716, '智化寺'],
    [116.198213, 40.003404, '碧云寺'],
    [116.672624, 39.921144, '三教庙'],
    [116.350158, 39.906520, '白云观'],
    [116.271736, 39.805355, '大王庙'],
    [116.435320, 39.921927, '法兴寺'],
    [115.927283, 40.124144, '白瀑寺'],
    [116.366616, 39.916302, '都城隍庙'],
    [116.098082, 40.109583, '龙泉寺'],
    [116.877093, 40.407271, '普照寺'],
    [116.432527, 39.950174, '通教寺'],
    [116.688075, 39.801451, '普渡寺'],
    [116.416976, 39.943954, '城隍庙'],
    [116.315893, 40.006680, '正觉寺'],
    [116.336963, 39.950627, '五塔寺(石刻艺术博物馆)'],
    [116.112780, 40.058452, '大觉寺'],
    [116.369903, 39.930764, '白塔寺'],
    [116.411150, 39.919839, '普度寺'],
    [116.401949, 39.943353, '火德真君庙'],
    [116.363911, 39.918655, '吕祖宫'],
    [116.388494, 39.887827, '三圣庵'],
    [116.396854, 39.971081, '西黄寺'],
    [116.213865, 40.012359, '十方普觉寺'],
    [116.318600, 39.953365, '万寿寺'],
    [116.344588, 39.974780, '觉生寺'],
    [116.188101, 39.965449, '大悲寺'],
    [116.165432, 39.979185, '双泉寺'],
    [116.165922, 39.947874, '法海寺'],
    [116.171263, 39.942378, '承恩寺'],
    [115.683018, 40.005944, '灵岳寺'],
    [116.071248, 40.229391, '和平寺'],
    [116.332579, 40.382705, '延寿寺'],
    [115.902643, 39.624332, '天开寺'],
    [115.846573, 39.697654, '药师寺'],
    [115.585847, 39.634650, '乐佛寺'],
    [116.784930, 40.494381, '大云峰禅寺'],
    [116.163643, 39.985879, '慈善寺'],
    [116.410354, 39.934753, '智珠寺'],
    [116.402965, 39.933812, '寿皇殿'],
    [116.399716, 39.930739, '大高玄殿'],
    [116.406236, 39.917784, '太庙'],
    [116.401278, 39.917546, '社稷坛'],
]

var ertong = [
    [116.399085, 39.977470, '北京科学中心'],
    [116.344820, 39.946348, '动物园'],
    [116.328650, 39.505009, '大兴野生动物园'],
    [116.405040, 40.012384, '中国科学技术馆'],
    [116.325721, 39.918496, '宋庆龄科学技术馆'],
    [116.312678, 39.924803, '太平洋海底世界'],
    [116.294039, 39.816781, '世界公园'],
    [116.215518, 39.917811, '石景山游乐园'],
    [116.500997, 39.873927, '欢乐谷'],
    [116.687820, 39.860990, '环球度假区'],
    [116.330065, 39.949641, '国家图书馆'],
    [116.469182, 39.875885, '首都图书馆'],
    [116.450539, 39.932873, '法国文化中心'],
    [116.407571, 39.974156, '朝阳区少儿图书馆'],
    [116.197868, 39.917206, '石景山儿童图书馆'],
    [116.168305, 39.944034, '第四纪冰川遗迹陈列馆'],
    [117.072789, 40.503935, '蜜蜂大世界'],
    [117.098410, 40.521656, '欢乐松鼠谷'],
    [116.708914, 40.300749, '鹿世界主题园'],
    [116.803181, 40.182960, '七彩蝶园'],
    [116.513617, 39.943052, '蜜糖国'],
    [116.283096, 39.918294, 'MELAND'],
    [116.197707, 39.763601, '广阳恐龙寻宝乐园'],
    [116.205892, 39.919167, '石景山区科技馆'],
    [116.160730, 39.801749, '五洲植物乐园'],
    [116.453462, 39.934256, '富国海底世界'],
    [116.305101, 39.830975, '探洞工场(万达广场丰科店)'],
    [116.488083, 39.945595, '勇敢者乐园'],
    [116.547737, 39.881757, '熊猫亲子乐园'],
    [116.236735, 39.942853, '赶海+航空'],
    [116.255328, 39.890163, '欢乐水魔方'],
    [116.687748, 39.858481, '环球影城'],
    [116.367991, 39.939732, '老牛儿童探索馆'],
    [116.224244, 40.143135, '中国京西皮影博物院'],
    [116.382444, 40.077344, '造梦空间蹦床乐园'],
]


var outDoor = [
    [116.514308, 40.032029, '浩华文创园'],
    [116.492471, 40.082575, '温榆河公园'],
    [116.542251, 40.005606, '黑桥公园'],
    [116.482157, 39.977940, '四得公园'],
    [116.451579, 40.035453, '禧园'],
    [116.340636, 40.021669, '东升八家郊野公园'],
    [116.310945, 40.032247, '树村郊野公园'],
    [116.546268, 39.904849, '砖窑里文创园'],
    [116.398185, 40.078411, '奥北森林公园'],
    [116.401111, 40.073702, '太平郊野公园'],
    [116.274714, 40.217733, '白浮泉公园'],
    [116.437880, 40.262200, '静之湖'],
    [116.124710, 39.871839, '北宫国家森林公园'],
    [116.231043, 39.920554, '老山城市休闲公园'],
    [116.430160, 39.821636, '世界之花'],
    [116.334943, 39.786951, '阳光拍拍熊列车主体乐园'],
    [116.030082, 40.293197, '阳台子村浅水滩'],
    [116.259515, 39.948463, '外国语腾飞校区浅水滩'],
    [116.274714, 40.217733, '白浮泉公园'],
    [116.580373, 39.955837, '东坝公园'],
    [116.519894, 39.982383, '将府公园'],
    [116.391804, 39.963551, '人定湖公园'],
]

var juchang = [
    [116.379436, 39.954111, '解放军歌剧院'],
    [116.468570, 39.897740, '北京歌舞剧院'],
    [116.443150, 39.935238, '中央歌剧院'],
    [116.434396, 39.864886, '中国歌剧舞剧院'],
    [116.478908, 39.957486, '世纪剧院'],
    [116.394215, 39.858763, '北京京剧院'],
    [116.394154, 39.952157, '鼓楼西剧场'],
    [116.397782, 39.948421, '广茗阁'],
    [116.412520, 39.942424, '蓬蒿剧场'],
    [116.418334, 39.927887, '首都剧场'],
    [116.342878, 39.895927, '国家话剧院剧场'],
    [116.423455, 39.916618, '国家话剧院先锋剧场'],
    [116.445202, 39.946149, '蜂巢剧场'],
    [116.421910, 39.931621, '东宫影剧院'],
    [116.410661, 39.945084, '北京儿童艺术剧院'],
    [116.414927, 39.921287, '中国儿童艺术剧院'],
    [116.350546, 39.947607, '北展剧场'],
    [116.478908, 39.957486, '世纪剧院'],
    [116.410656, 39.945342, '南锣剧场'],
    [116.324960, 39.982536, '海淀剧院'],
    [116.376727, 39.987335, '国安剧院'],
    [116.317193, 39.953650, '八一剧场'],
    [116.407787, 39.974563, '木偶艺术剧院'],
    [116.322663, 39.917670, '未来剧院'],
    [116.418988, 39.947532, '东图剧场'],
]

var shangchang = [
    [116.603045, 40.016812, '斯普瑞斯奥特莱斯'],
    [116.494280, 39.883897, '燕莎奥特莱斯购物中心'],
    [116.512258, 40.041838, '北京赛特奥莱'],
    [116.176188, 40.240957, '八达岭奥特莱斯'],
    [116.331261, 39.833241, '花乡奥莱村'],
    [116.194065, 39.769172, '首创奥特莱斯'],
]

var huabing = [
    [116.465087, 39.916776, '国贸溜冰场(国贸写字楼2座店)'],
    [116.334300, 39.949296, '首都滑冰馆'],
    [116.304107, 39.941913, '星宏奥冰上运动发展中心(昆玉店)'],
    [116.241202, 39.914821, '启迪冰雪体育中心'],
    [116.217710, 39.759078, '世纪星滑冰场'],
    [116.397319, 39.942244, '什刹海冰场'],
    [116.339176, 40.035950, '冰酷(清河万象汇店)'],
    [116.296970, 39.965486, '冠军溜冰场'],
    [116.205397, 39.931245, '首钢溜冰场'],
    [116.607626, 39.930674, '全明星滑冰俱乐部'],
    [116.422170, 40.066097, '浩泰冰上运动中心'],
    [116.486374, 40.057440, '华星国际冰上运动中心'],
    [116.487340, 39.892443, '陈露国际冰上中心'],
    [116.483953, 39.955386, '全明星滑冰俱乐部'],
    [116.525101, 39.929899, '冠军溜冰场(朝阳大悦城店)'],
    [116.395166, 39.929757, '北海公园冰场'],
    [116.568101, 40.019566, '奥众冰上运动俱乐部'],
    [116.327155, 39.693321, 'xixo喜悦滑冰场'],
    [116.546509, 39.954367, '小狼国际滑冰俱乐部'],
    [116.614289, 39.970209, '蓝调庄园滑雪场'],
    [116.546067, 39.952355, '庞清佟健冰上艺术中心'],
    [116.317864, 40.001054, '北京大学未名湖冰场'],
    [116.631965, 40.324703, '中体奥冰壶运动中心'],
    [116.429602, 39.825516, '欧悦滑冰俱乐部'],
    [116.423663, 39.902376, '浩泰冰上运动中心'],
    [116.441968, 40.014250, '梦想冰场'],
    [115.989394, 40.480319, '梦起源滑冰馆'],
    [116.289169, 39.915556, '五棵松冰上运动中心'],
    [116.254405, 40.199634, '汇佳-绿雪冰场'],
    [116.324208, 39.918930, '八一湖冰场'],
    [116.487746, 39.953768, '朝阳公园-冰场'],
    [116.371230, 39.965328, '师范大学-四季冰场'],
    [116.325687, 40.006310, '清华大学西湖冰场'],
    [116.423013, 39.963311, '地坛滑冰馆'],
    [116.698077, 40.178809, '顺奥冰世界'],
    [116.289506, 39.915888, '华熙LIVE冰上中心'],
    [116.158814, 39.922950, '首钢园国家冬季训练中心-花滑馆'],
    [116.350544, 39.822861, '新发地市场制冰场'],
    [116.470618, 39.931562, '团结湖公园-轮滑场'],
    [116.516210, 40.176343, '海源春旱冰场'],
]

var beijing = [
    {
        name: '博物馆',
        list: bowuguan,
        show: true,
        group: 'base',
        color: 'red'
    },
    {
        name: '景点',
        list: jingdian,
        show: true,
        group: 'base',
        color: 'green'
    },
    {
        name: '儿童',
        list: ertong,
        show: true,
        group: 'base',
        color: 'blue'
    },
    {
        name: '商场',
        list: shangchang,
        show: false,
        group: 'base',
        color: 'plum'
    },
    {
        name: '剧场',
        list: juchang,
        show: false,
        group: 'base',
        color: 'plum'
    },
    {
        name: '寺庙',
        list: simiao,
        show: false,
        group: 'base',
        color: 'auqamarin'
    },
    {
        name: '滑冰',
        list: huabing,
        show: false,
        group: 'base',
        color: 'plum'
    },
    {
        name: '免费户外',
        list: outDoor,
        show: false,
        group: 'base',
        color: 'plum'
    },
    {
        name: '未出行',
        group: 'level1',
        list: notTo,
        show: false,
        color: 'plum'
    }
]

export default beijing;